export default {
  select: 'select',
  multiselect: 'multiselect',
  text: 'text',
};
